<template>
  <div class="img_upload">
    <div
      class="img_item"
      :class="
        !onlyShow && index === optionalNumber + requiredNumber - 1 ? 'plus' : ''
      "
      v-for="(item, index) in imgNumber"
      :style="titleList.length > 0 ? { paddingBottom: '21px' } : {}"
      :key="index"
    >
      <div
        :class="
          titleList.length > 0
            ? `mask with_title ${!imgValue[index] && showErro ? 'no_img' : ''}`
            : `mask ${!imgValue[index] && showErro ? 'no_img' : ''}`
        "
      >
        <input
          :multiple="multiple && index >= requiredNumber"
          :disabled="onlyShow"
          :capture="capture"
          type="file"
          :ref="`input${index}`"
          @change="(val) => imgChange(index, val)"
          :accept="capture ? 'image/*' : 'image/jpeg, image/png'"
        />
        <span v-if="index !== optionalNumber + requiredNumber - 1" class="icon iconfont iconcamera"></span>
        <span v-else class="icon iconfont iconadd" style="opacity: 0.8">
          <span style="opacity: 1"></span>
        </span>
      </div>
      <div class="little_title">
        {{ titleList[index] }}
        <span v-if="index < requiredNumber && !onlyShow" style="color: red">*</span>
      </div>
      <div
        class="img_box"
        :style="titleList.length > 0 ? { height: 'calc(100% - 21px)' } : {}"
        v-if="imgValue[index]"
        @click="show(index)"
      >
        <img class="previewer-img" :src="`${url}${imgValue[index]}`" alt />
        <div
          class="icon_clear"
          @click.stop="clear(index)"
          v-if="!onlyShow && (canDel || index + 1 > noDelNum)"
        >
          <van-icon name="close" class="icon svg-icon" />
        </div>
        <!-- <svg v-if="!onlyShow && (canDel || index + 1 > noDelNum)" slot="icon" class="icon svg-icon" aria-hidden="true" @click.stop="clear(index)">
            <use xlink:href="#iconRemovepicture"></use>
        </svg>-->
      </div>
    </div>
    <div>
      <!-- <Previewer :list="imgList" ref="previewer" :options="options"  @on-close="closePre"></Previewer> -->
      <van-image-preview :images="imgList" ref="previewer" @close="closePre"></van-image-preview>
    </div>
  </div>
</template>
<script>
import { getToken } from '@/utils/auth'
import lrz from 'lrz'
import axios from 'axios'
export default {
  name: 'Imgs',
  props: {
    requiredNumber: {
      type: Number,
      default: 0
    },
    optionalNumber: {
      type: Number,
      default: 0
    },
    onlyShow: {
      type: Boolean,
      default: false
    },
    showList: {
      type: Array,
      default: () => {
        return []
      }
    },
    titleList: {
      type: Array,
      default: () => {
        return []
      }
    },
    showErro: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    capture: {
      type: Boolean,
      default: false
    },
    remote: {
      type: Boolean,
      default: false
    },
    bId: {
      type: String,
      default: ''
    },
    canDel: {
      type: Boolean,
      default: true
    },
    noDelNum: {
      type: Number,
      default: 999
    }
  },
  computed: {
    imgNumber() {
      return new Array(this.requiredNumber + this.optionalNumber)
    },
    imgList() {
      const list = []
      if (this.onlyShow && this.showList.length > 0) {
        this.showList.forEach((item, index) => {
          if (item) {
            list.push({
              src: `${this.url}${item}`
            })
          }
        })
        return list
      }
      this.imgValue.forEach((item, index) => {
        if (item) {
          list.push({
            src: `${this.url}${item}`
          })
        }
      })
      return list
    },
    requiredOk() {
      let flag = true
      for (let i = 0; i < this.requiredNumber; i++) {
        if (!this.imgValue[i]) {
          flag = false
        }
      }
      return flag
    }
  },
  data() {
    const that = this
    return {
      imgValue:
        this.onlyShow && this.showList.length > 0
          ? this.showList
          : new Array(this.requiredNumber + this.optionalNumber),
      options: {
        loop: false,
        // loadingIndicatorDelay: 500,
        fullscreenEl: false,
        timeToIdle: 500,
        preload: [1, 1],
        getThumbBoundsFn(index) {
          // find thumbnail element
          const thumbnail = that.$el.querySelectorAll('.previewer-demo-img')[
            index
          ]
          // get window scroll Y
          if (!thumbnail) {
            return
          }
          const pageYScroll =
            window.pageYOffset || document.documentElement.scrollTop
          // optionally get horizontal scroll
          // get position of element relative to viewport
          const rect = thumbnail.getBoundingClientRect()
          // w = width
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
          // Good guide on how to get element coordinates:
          // http://javascript.info/tutorial/coordinates
        }
      },
      url: process.env.VUE_APP_API_URL,
      time: new Date().getTime()
    }
  },
  methods: {
    async imgChange(index, val) {
      const files = val.target.files
      if (files.length < 1) {
        return
      }
      if (files.length > 9) {
        this.$toast({
          message: '一次最多上传9张图片'
        })
        return
      }
      let hasOverSize = false
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const lrzUrl = URL.createObjectURL(file, { quality: 0 })
        lrz(lrzUrl).then(async (rst) => {
          if (rst.fileLen > 10 * 1024 * 1024) {
            hasOverSize = true
          }
        })
      }
      if (hasOverSize) {
        this.$toast({
          message: '图片尺寸过大'
        })
        this.imgValue[index] = ''
        return
      }
      this.$toast.loading({
        duration: 0,
        message: '上传中...'
      })
      const urlList = []
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const uploadUrl = this.remote
          ? process.env.VUE_APP_API_URL + '/mesv2/remote/upload/img'
          : process.env.VUE_APP_API_URL + '/mesv2/file/upload'
        const lrzUrl = URL.createObjectURL(file, { quality: 0 })
        const promise = new Promise((resolve, reject) => {
          // lrz(lrzUrl).then(async rst => {
          const formData = new FormData()
          formData.append('file', file)
          if (this.remote) {
            formData.append('bId', this.bId)
          }
          axios({
            url: uploadUrl,
            method: 'post',
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: getToken()
            },
            data: formData
          }).then(
            (row) => {
              const res = row.data
              if (res.code === 200 || res.code === 20000) {
                resolve(res.data.url)
              } else {
                reject(res)
              }
            },
            (error) => {
              reject(error)
            }
          )
          // })
        })
        urlList.push(promise)
      }
      Promise.all(urlList)
        .then((values) => {
          values.forEach((x, y) => {
            this.$set(this.imgValue, index + y, x)
          })
          if (this.multiple) {
            if (index === this.requiredNumber + this.optionalNumber - 1) {
              this.addImgItem(values.length)
            } else if (index < this.requiredNumber) {
              this.addImgItem()
            } else {
              // 计算空位
              let e = 0
              for (let x = index; x < values.length + index - 1; x++) {
                if (!this.imgValue[index]) {
                  e++
                }
              }
              this.addImgItem(values.length - e)
            }
          } else {
            if (index === this.requiredNumber + this.optionalNumber - 1) {
              this.imgValue[index + 1] = ''
              this.addImgItem()
            }
          }
          this.$toast.clear()
        })
        .catch(() => {
          this.$toast({
            message: '上传失败'
          })
          this.$toast.clear()
          this.imgValue[index] = ''
        })
      event.target.value = ''
    },
    show(index) {
      if (new Date().getTime() - this.time < 2000) {
        return
      }
      this.time = new Date().getTime()
      let count = 0
      for (let i = 0; i < this.imgValue.length; i++) {
        if (this.imgValue[i] && i <= index) {
          count++
        }
      }
      this.$refs.previewer.close()
      if (document.getElementsByClassName('pswp--open').length > 0) {
        return
      }
      this.$refs.previewer.show(count ? count - 1 : 0)
    },
    clear(index) {
      if (index >= this.requiredNumber) {
        this.imgValue.splice(index, 1)
        this.$emit('deleteImgItem')
        if (index === this.imgValue.length - 1) {
          this.$refs[`input${index}`][0].value = ''
        }
      } else {
        this.$refs[`input${index}`][0].value = ''
        this.$set(this.imgValue, index, '')
      }
    },
    addImgItem(length) {
      if (length > 0) {
        this.$emit('addImgItem', length, this.imgValue)
      } else {
        this.$emit('addImgItem')
      }
    },
    closePre() {
      if (document.getElementsByClassName('pswp--open').length > 0) {
        this.removeClass(
          document.getElementsByClassName('pswp--open').item(0),
          'pswp--open'
        )
      }
      this.$refs.previewer.close()
    },
    hasClass(obj, cls) {
      return obj.className.match(/(\s|^)' + cls + '(\s|$)'/)
    },
    removeClass(obj, cls) {
      if (this.hasClass(obj, cls)) {
        const reg = /(\s|^)' + cls + '(\s|$)/
        obj.className = obj.className.replace(reg, ' ')
      }
    }
  }
}
</script>

<style lang="less">
.pswp__button.pswp__button--fs {
  display: none !important;
}
.img_upload {
  .img_item:nth-of-type(3n) {
    margin-right: 0;
  }
  .img_item.plus {
    // border: 1px dashed rgba(53, 93, 180, 0.2);
    margin-right: 0;
    .mask {
      border: 1px dashed rgba(53, 93, 180, 0.2);
    }
    .no_img.mask {
      border-color: rgba(53, 93, 180, 0.2);
      .icon {
        color: #355db4;
        opacity: 0.2;
      }
    }
  }
  .img_item {
    vertical-align: middle;
    margin-top: 16px;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 16px;
    width: calc(~"(100% - 32px) / 3");
    overflow: hidden;
    position: relative;
    // padding-bottom: 21px;
    input {
      width: 100%;
      height: 0;
      padding-bottom: calc(~"100% - 0px");
      padding-top: 2px;
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .mask {
      border: 1px solid rgba(53, 93, 180, 0.2);
      height: 0;
      padding-bottom: 100%;
      span {
        position: absolute;
        top: calc(~"50% - 18px");
        left: calc(~"50% - 18px");
        width: 36px;
        height: 36px;
        font-size: 36px;
        line-height: 36px;
        color: #355db4;
        opacity: 0.2;
      }
    }
    .no_img.mask {
      border-color: #fa5151;
      .icon {
        color: #fa5151;
        opacity: 1;
      }
    }
    .with_title.mask {
      span {
        top: calc(~"50% - 28px");
        left: calc(~"50% - 18px");
      }
    }
    .little_title {
      height: 15px;
      line-height: 15px;
      padding: 6px 0 0;
      position: absolute;
      bottom: 0px;
      left: 0;
      right: 0;
      font-size: 15px;
      color: #000;
      text-align: center;
    }
    .img_box {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      svg {
        position: absolute;
        top: 0;
        right: 0;
        width: 24px;
        height: 24px;
      }
    }
    img {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      margin: auto;
    }
  }
  .icon_clear {
    position: absolute;
    right: 3px;
    top: -2px;
  }
}
.iconadd {
  // width: 100%;
  // height: 100%;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // flex-flow: column;
  // font-size: 18px;
  // color: #646566;
  span {
    display: block;
    position: relative;
    width: 40px;
    height: 40px;
    top: 16px;
    opacity: 1;
  }
  span::before,
  span::after {
    background: #346ddc;
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  span::before {
    content: " ";
    width: 40px;
    height: 4px;
  }
  span::after {
    content: " ";
    width: 4px;
    height: 40px;
  }
}
</style>
